<template>
	<v-row
		justify = "center"
		align   = "center"
	>
		<v-col 
			xl   = "8"
			lg   = "10"
			md   = "10"
			sm   = "10"
			xs   = "12"
			cols = "12"
		>
			<v-card outlined>
				<v-card-title
					class = "pa-0 subtitle-1 secondary white--text"
				>	
					<v-icon 
						small 
						color  = "white"
						class  = "ml-1"
						@click = "$router.back()"
					>
						mdi-arrow-left-circle
					</v-icon>
					
					<v-spacer></v-spacer>
					<v-icon
						small
						color  = "primary"
						class  = "px-2"
						v-text = "'mdi-map-marker-star'"
					></v-icon>
					<span 
						v-text = "$ml.get('zones')"
					></span>
					
					<v-spacer></v-spacer>
					

				</v-card-title>
				<v-card-text
					:class = "heads.class_text"
				>
					<v-row
						dense
					>
						<v-col 
							xl   = "2"
							lg   = "2"
							md   = "2"
							sm   = "3"
							xs   = "3"
							cols = "3"
							v-show = "show.add_zone"
							
						>
							<v-card
							>
								<v-card-title
									class = "pa-1 secondary body-2 white--text"
								>
									<v-icon
										x-small
										color = "white"
										class = "mx-1"
									>
										mdi-form-select
									</v-icon>
									{{ $ml.get('options') }}
								</v-card-title>
								<v-card-text class = "pa-1">
									<v-list dense>
										<v-list-item-group
										 	color = "primary"
										>
											<template
												v-for = "(btn_option, btn_index) of option_conts"
												v-if  = "btn_option.enable"
											>	
												<v-card 
													outlined
													:color = "btn_option.color"			
												>
												<v-list-item 
													:key   = "btn_index"	
													@click = "redirect(btn_option.btn_action ,btn_option.key)"	
												>																<v-list-item-icon
													 		class = "mx-0"
													 	>
											            	<v-icon 
											            		small
											            		color  = "white"
											            		v-text = "btn_option.icon"
											           		></v-icon>
											        </v-list-item-icon>	
													<v-list-item-title
														class  = "white--text"
														v-text = "btn_option.title"
													></v-list-item-title>
												</v-list-item>
											</v-card>
											</template>
										</v-list-item-group>
									</v-list>
								</v-card-text>
							</v-card>
						</v-col>
						<v-col>
							<v-toolbar
					    		dense
					    		height = "25"
					    		class  = "secondary white--text"
					    	>
					    		<v-icon
									small
									color = "white"
									class = "mr-1"
								>
									mdi-view-list
								</v-icon>
					    		<v-toolbar-title 
					    			class = "body-2"
					    		>
					    			{{ $ml.get('registered_zones') }}
					    		</v-toolbar-title>
					    	</v-toolbar>
							<v-divider></v-divider>
							<v-data-table
								dense
							    fixed-body
							    fixed-header
								:headers  			 = "header_table"
								:items 				 = "render_list"
								class 				 = "elevation-5"
							   	loading-text 		 = "Loading... Please wait"
							   	:loading 			 = "false"
							    item-key 			 = "index"
							    :height 			 = "layout_height+'px'"
								:options.sync 	 	 = "options"
							   	:server-items-length = "total"
							   	:footer-props 		 = "{
							   		showFirstLastPage   : true,
							   		itemsPerPageOptions : [15, 30],
							   		showCurrentPage     : true,
							   		itemsPerPageText 	: ''
							   	}"
							   	
							>
							    <!-- rowsPerPageText: [30] -->
								<template v-slot:item.actions = "{ item }" >
									<v-btn
										x-small
										color  = "primary"
										@click = "redirect('settings_zones', item)"
										v-show = "show.edit_zone"
									>
										<v-icon
											x-small
											v-text = "'mdi-pencil'"
										></v-icon>
									</v-btn>	
									<v-btn
										x-small
										color 	= "error"
										class 	= "mx-1"
										@click 	= "actions('confirm_delete', item)"
										v-show  = "show.delete_zone"
									>
										<v-icon
											x-small
											v-text="'mdi-delete'"
										></v-icon>
									</v-btn>							
								</template>
							</v-data-table>

						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>
<script>
	import axios from 'axios'

	export default {
		name: 'add_zone',
		data: (vm) => ({
			info 		: {},
			info_item 	: null,
			heads 		: {
				class_text 		: "pa-1",
			}, 
			header_table : [
				{ text: vm.$ml.get('name'), value: 'name' },
				{ text: vm.$ml.get('zones'), value: 'constellation' },
				
			],
			options 		: {},
			total   		: 1,
			layout_height 	: 400,
			option_conts  	: [
				{ 
					title 		: 'New', 
					color 		: 'primary', 
					enable 		: true, 
					btn_action 	: 'settings_zones', 
					key 		: 'new',
					icon 		: "mdi-map-marker-plus"  
				},
			],
			list : [],
			show : {
				add_zone 	: false,
				edit_zone  	: false,
				delete_zone : false,
			},
			bus 			: {},
			ID_notification : "add_zone",
		}), // data

		created(){
			this.get_constellation();
      		// if (this.$Helper.current_auth_user(this.currentUser, {roles : [1, 2]})) {
      		if (this.$route && this.$route.name) {
      			console.log(this.$store.getters["auth/permission"](this.$route.name || "zones"))
	      		if (this.$store.getters["auth/permission"](this.$route.name || "zones", "can_add", "zones")) {
	      			this.show.add_zone = true;
	      		}
	      		if (this.$store.getters["auth/permission"](this.$route.name || "zones", "can_edit", "zones")) {
	      			this.show.edit_zone = true;
	      			this.header_table.push({ text: this.$ml.get('actions'), value: 'actions' });
	      		}
	      		if (this.$store.getters["auth/permission"](this.$route.name || "zones", "can_delete", "zones")) {
	      			this.show.delete_zone = true;
	      			if (!this.$store.getters["auth/permission"](this.$route.name || "zones", "can_edit", "zones")) {
	      				this.header_table.push({ text: this.$ml.get('actions'), value: 'actions' });
	      			}

	      		}
      		}

		}, // created

		computed: {
			render_list: function (){
				return this.list;
			}, // render list

			currentUser(){
		      return this.$store.state.auth.user;
		    }, // currentUser

		}, // computed

		methods:{
			actions(act, item, opt){
				if (act == "confirm_delete") {
					this.info_item = {...item};
					this.$EventBus.$emit('notifications_modal', { 
						type : 'confirm_delete',
						ID   : this.ID_notification,
					});
				}
			}, // actions

			get_constellation(){				
				const api = this.$URL + '/api/v1/constellation/';

				try {

					this.$axios.get(api).then( res => {
						console.log(res, 'Res get constellation');					
						if (res && res.data) {
							if (res.data.rows && res.data.rows.length > 0) {
								this.total = res.data.count; 
								let items  = res.data.rows;
								items.sort(function(a,b){
								  // Turn your strings into dates, and then subtract them
								  // to get a value that is either negative, positive, or zero.
								  return    new Date(b.createdAt) - new Date(a.createdAt);
								});
								this.list = [...items];
								this.save_local();
							}else{
								this.list = [];
																
							}
						}
					}).catch( er => {
						console.log(er, 'Error get constellation');
						// throw "Error Get Constellation";
						// EventBus.$emit('notifications_modal', { type: 'error' });
					});
				}catch (er){
					console.log(er, 'Error 2 get Constellation');
					this.get_list();
				}
			},

			get_list(){
				let list_temp = [];
				if (localStorage.getItem('constellations')) {
					list_temp = JSON.parse(localStorage.getItem('constellations'));
					this.list = list_temp;
				}else{
					console.log('Error get constellation');
				}
				console.log(list_temp);
			},

			save_local(){
				// if (localStorage.getItem('constellations')) {
				localStorage.setItem('constellations', JSON.stringify([...this.list]));
				// }
			}, // save local

			redirect(url, type){
				localStorage.setItem('constellation_redirect', JSON.stringify(type));
				if (this.$route.name !== url) {
					this.$router.push({ name: url }).catch(err => {
						if (err.name !== 'NavigationDuplicated') throw err;
					});
				}
			}, // redirect

			delete(){
				const info_up = this.info_item;
				if (info_up && info_up.id) {


					const api = this.$URL + '/api/v1/constellation/' + info_up.id;
					this.$axios.delete(api).then( res => {
						this.delete_local();
						// this.update_local(res.data, true);						

					}).catch( er => {
						console.log(er, 'Error update zone');						
						
						this.$EventBus.$emit('notifications_modal', { 
							type 	: 'error', 
							message : er 
						});
					})
				}else{
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'warning',
						message : this.$ml.get('req_id_del')
					})
				}
				

			}, // delete

			delete_local(){
				const info_up 	= this.info_item;
				let list_temp 	= [];
				let vn 			= this;

				const finded = vn.list.some( function(arr_list, idx_list){
					if (arr_list.id == info_up.id) {
						vn.list.splice(idx_list,1);
						return true
					}
				})
				if (finded) {
					list_temp = JSON.stringify([...this.list]);					
					localStorage.setItem('constellations', list_temp);
					this.$EventBus.$emit('notifications_modal', { type: 'deleted' });					
				}else{
					this.$EventBus.$emit('notifications_modal', { type: 'deleted' });
					
				}
				this.info_item 	   = {};
				// this.show_progress = false;
			}, // delete local

		}, // methods
		
		mounted(){
			let id = 'notifications_modal' + this.ID_notification;
			this.$EventBus.$on(id, this.bus[id] = (action) => {
				console.log(action, 'action del');
				if (action){
					this.delete();
				}
			});

		}, // mounted

		beforeDestroy(){
			this.$Helper.clear_bus(this.$EventBus, this.bus, this.ID_notification);
		}
	};  // export
</script>